/**
 * Lightweight vanilla-JS toast — works anywhere (React components, api.js, etc.)
 * No dependencies. Auto-dismisses after `duration` ms.
 *
 * Usage:
 *   import { showToast } from "../utils/toast";
 *   showToast("Something went wrong. Please try again.", "error");
 *   showToast("Saved successfully!", "success");
 *   showToast("Please check your internet connection.", "warning");
 */

const COLORS = {
  error:   { bg: "#d32f2f", icon: "✕" },
  success: { bg: "#2e7d32", icon: "✓" },
  warning: { bg: "#e65100", icon: "⚠" },
  info:    { bg: "#1565c0", icon: "ℹ" },
};

let container = null;

function getContainer() {
  if (container && document.body.contains(container)) return container;

  container = document.createElement("div");
  container.id = "app-toast-container";
  Object.assign(container.style, {
    position:      "fixed",
    top:           "20px",
    right:         "20px",
    zIndex:        "99999",
    display:       "flex",
    flexDirection: "column",
    gap:           "10px",
    pointerEvents: "none",
  });
  document.body.appendChild(container);
  return container;
}

export function showToast(message, type = "error", duration = 4000) {
  const c = COLORS[type] || COLORS.error;

  const toast = document.createElement("div");
  Object.assign(toast.style, {
    display:      "flex",
    alignItems:   "center",
    gap:          "10px",
    background:   c.bg,
    color:        "#fff",
    padding:      "12px 18px",
    borderRadius: "8px",
    boxShadow:    "0 4px 12px rgba(0,0,0,0.25)",
    fontSize:     "14px",
    maxWidth:     "340px",
    lineHeight:   "1.4",
    pointerEvents:"auto",
    opacity:      "0",
    transition:   "opacity 0.3s ease",
  });

  toast.innerHTML = `
    <span style="font-size:16px;font-weight:bold;flex-shrink:0">${c.icon}</span>
    <span>${message}</span>
  `;

  getContainer().appendChild(toast);

  // Fade in
  requestAnimationFrame(() => {
    requestAnimationFrame(() => { toast.style.opacity = "1"; });
  });

  // Auto-dismiss
  setTimeout(() => {
    toast.style.opacity = "0";
    setTimeout(() => toast.remove(), 320);
  }, duration);
}
